import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AppComponent} from "../../../app.component";
import {SharedDataService} from "../../../services/shared-data.service";
import {MatDialog} from "@angular/material/dialog";
import {ListItem} from "../../../objects/listItem";
import {FormControl, FormGroup} from "@angular/forms";
import {FS3Notification} from "../../../objects/notification";

@Component({
  selector: 'app-service-picker-popup',
  templateUrl: './service-picker-popup.component.html',
  styleUrls: ['./service-picker-popup.component.css']
})
export class ServicePickerPopupComponent implements OnInit {
  @Input() application: AppComponent;
  @Input() payload: object;
  @Output() close = new EventEmitter<void>();
  @Output() success = new EventEmitter<object>();

  public componentForm: FormGroup = new FormGroup({});
  profileID: number;
  trainers: object[];
  packages: object[];
  packageGroups: string[] = [];
  packagesGrouped: object[][] = [];
  pickItemsLoading: boolean = false;
  state: string = 'default';
  mode: string;
  errMsg: string = '';

  constructor(public sharedDataService: SharedDataService,
              public dialog: MatDialog,
              public confirmationDialog: MatDialog) {
  }

  ngOnInit(): void {
    this.profileID = this.payload['profileID'];
    this.trainers = this.payload['trainers'];
    this.packages = this.payload['packages'];
    this.mode = this.payload['mode'];
    this.packages.forEach(packageItem => {
      if(!this.packageGroups.find(item => item == packageItem['package_group_name'])) {
        this.packageGroups.push(packageItem['package_group_name'])
        this.packagesGrouped.push([])
      }
      this.packagesGrouped[this.packageGroups.indexOf(packageItem['package_group_name'])].push(packageItem)
    })
    this.addFormControls()
  }

  public addFormControls(): void {
    this.packagesGrouped.forEach((packagesGroup, gdx) => {
      packagesGroup.forEach((packageItem, idx) => {
        packageItem['services'].forEach((service, jdx) => {
          if(service['params']['unit'] == 'training') {
            const trainerPickControl = new FormControl();
            trainerPickControl.setValue(0)
            this.componentForm.addControl('trainerPickControl_'+gdx+'_'+idx+'_'+jdx, trainerPickControl);
          }
          if(service['status'] == 'BUNDLED') {
            const checkBundledControl = new FormControl();
            if(!service['bundle_picker']) checkBundledControl.setValue(true) //pick manually when has bundle_picker
            this.componentForm.addControl('checkBundledControl_'+gdx+'_'+idx+'_'+jdx, checkBundledControl);
          }
        })
      });
    })
  }

  public uncheckBundled(bundle_picker,gdx,idx,jjdx): void {
    if(!bundle_picker) return;
    this.packagesGrouped[gdx][idx]['services'].forEach((service, jdx) => {
      if(service['bundle_picker'] != bundle_picker ) return;
      if(jjdx != jdx) { //uncheck others. checkboxes act like radio button
        this.componentForm.get('checkBundledControl_'+gdx+'_'+idx+'_'+jdx).setValue(false);
      }
    });
  }

  public saveService(gdx,idx): void {
    let packageToSave = this.packagesGrouped[gdx][idx]
    packageToSave['usage_services'] = [];
    packageToSave['__validated'] = true;
    packageToSave['__valid'] = true;
    packageToSave['services'].forEach((service, jdx) => {
      if(service['params']['unit'] == 'training' && !this.componentForm.get('trainerPickControl_'+gdx+'_'+idx+'_'+jdx).value) {
        packageToSave['__valid'] = false;
        return
      } else if(service['params']['unit'] == 'training') {
        service['trainer_id'] = this.componentForm.get('trainerPickControl_'+gdx+'_'+idx+'_'+jdx).value;
        // service['trainer_name'] = this.trainers.find(trainer => trainer['ID'] == service['trainer_id'])['SHIPPING_NAME'];
      }
      if(service['status'] == 'general') {
        packageToSave['usage_services'].push(service);
      }
      if(service['status'] == 'BUNDLED' && this.componentForm.get('checkBundledControl_'+gdx+'_'+idx+'_'+jdx).value) {
        packageToSave['usage_services'].push(service);
      }
    });
    if(packageToSave['__valid']) {
      //this.success.emit({package: packageToSave})
      this.pickItemsLoading = true;
      const action = 'insert';
      packageToSave['proposal'] = this.mode == 'show_proposals' ? 'Y' : 'N';
      this.application.apiService
        .saveProfilePurchase(this.profileID,packageToSave,action)
        .subscribe(
          data => this.purchaseSaved(data),
          error => this.handleError(error))
    }
  }

  private purchaseSaved(data): void {
    this.pickItemsLoading = false;
    this.success.emit({saved: true, new_data: data})
  }
  private handleError(error): void {
    this.pickItemsLoading = false;
    let notification = new FS3Notification();
    notification.type = 'error';
    notification.text = error.errMsg;
  }

  public onNoClick(): void {
    this.close.emit()
  }
}
